export const downloadFile = (base64String, fileName) => {
  // Decode the base64 data into binary data
  const binaryData = atob(base64String)

  // Create a Uint8Array from the binary data
  const array = new Uint8Array(binaryData.length)
  for (let i = 0; i < binaryData.length; i++) {
    array[i] = binaryData.charCodeAt(i)
  }

  // Create a Blob from the Uint8Array
  const blob = new Blob([array], { type: 'application/octet-stream' })

  // Create a temporary URL for the Blob
  const url = URL.createObjectURL(blob)

  // Create a link element for download
  const a = document.createElement('a')
  a.href = url
  a.download = fileName // Set the desired file name and extension

  // Trigger the download
  document.body.appendChild(a)
  a.click()

  // Clean up the temporary URL
  URL.revokeObjectURL(url)
}

export const downloadPdf = (blob, fileName) => {
  const link = document.createElement('a')
  link.href = blob
  link.download = `${fileName}.pdf`
  link.click()
}
